<template>

  <panel-navigation>

    <!-- <div class="float-right ml-5 -mt-1">
      <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2" @click="$refs.dialogAddReview.show()" style="margin-top: -5px;"><i class="mdi mdi-plus mr-2"> </i> Add review manually</div>
    </div> -->
    
    <h1 class="text-lg font-semibold mb-3">AI Testing Suite</h1>

    <hr class="border-b border-gray-100 mb-3">

    <div class="dashboard-box stats-box w-full px-2 -mx-2" style="height: 97%;">
      <v-card
        class="pa-2 h-full"
        tile
      >
        <div class="flex flex-row flex-wrap p-3">
            <!-- <div class="mx-auto h-full bg-gray-50 flex p-3"> -->
                <div class="mb-4 w-full md:w-1/3 pr-5 sm:pr-0">
                    <p class="mt-1">Simulate conversations with your AI phone agent. See how the AI responds and update the prompt to improve outputs.</p>
                    <hr class="mt-4">
                    <p class="text-sm font-medium mb-1 mt-4">Model</p>
                    <select name="model" class="w-full p-2 border rounded focus:outline-none focus:border-dark" v-model="model">
                        <option value="base">Base</option>
                        <option value="enhanced">Enhanced</option>
                        <option value="turbo">Turbo</option>
                        <!-- <option value="gpt4">GPT4</option> -->
                    </select>
                    <p class="text-sm font-medium mb-1 mt-4">Language</p>
                    <select name="language" class="w-full p-2 border rounded focus:outline-none focus:border-dark" v-model="language">
                        <option value="ENG">ENG</option>
                        <option value="FRE">FRE</option>
                        <option value="ESP">ESP</option>
                        <option value="POL">POL</option>
                        <option value="PBR">PBR</option>
                    </select>
                    <p class="text-sm font-medium mb-1 mt-4">Prompt</p>
                    <textarea rows="20" name="task" placeholder="Insert your entire prompt here" v-model="prompt" class="text-left bg-white border border-accent w-full px-4 py-2 rounded placeholder-secondary focus:outline-none focus:border-dark"></textarea>
                </div>
                <div class="text-center w-full md:w-2/3 h-full text-sm  p-4 overflow-y-scroll bg-gray-50">
                    <div id="messages_div" class="h-[80vh] overflow-y-scroll relative" style="height: 73vh;">
                    
                        <button class="bg-dark text-white hover:bg-black font-medium transition-all py-2 px-4 rounded absolute right-1 top-0" style="position: absolute; right: 10px;" @click="clearMessages()">Clear Messages</button>
                        
                        <div v-for="(message, index) in messageArray" class="mt-4 message text-center wrap text-wrap bg-none text-center p-2 rounded w-3/4 flex flex-col">
                            <div class="flex w-full ">
                                <div class="flex w-full">
                                    <div class="flex space-x-2">
                                        <div v-if="message.role == 'user'" class="w-4 h-4 rounded-full my-auto    bg-blue-500 mr-2"></div>
                                        <div v-else class="w-4 h-4 rounded-full my-auto    bg-gray-900  mr-2"></div>
                                        
                                        <div v-if="message.role == 'user'" class="my-auto font-bold  flex flex-col text-left">user</div>
                                        <div v-else class="my-auto font-bold  flex flex-col text-left">[AI] </div>
                                    </div>
                                </div>
                            </div>
                            <span class="mt-1 w-full text-left ml-6 overflow-hidden focus:outline-none bg-transparent mb-4">{{ message.content }}</span>
                            <span class="flex mx-auto space-x-2"><span class="delete-icon cursor-pointer hover:text-red/50 duration-500 text-xs mt-2" @click="deleteMessage(index)">[🗑️ Delete Message]</span></span>
                        </div>
                    </div>
                        
                    <div class="flex  h-12 bg-transparent">
                        <div class="flex mx-auto w-3/4">
                            <input :disabled="sending" type="text" v-on:keyup.enter="sendMessage()" v-model="new_message" placeholder="Send a message..." class="text-left border border-accent w-3/4 px-4 py-2 rounded placeholder-secondary focus:outline-none focus:border-dark bg-white false" value="">
                            <button :disabled="sending" class="bg-dark text-white hover:bg-black font-medium transition-all py-2 px-4 rounded ml-2 flex items-center justify-center false" @click="sendMessage()"><span v-if="sending">Sending</span><span v-else>Send</span></button>
                        </div>
                    </div>
                </div>
            <!-- </div> -->
        </div>
      </v-card>
    </div>

  </panel-navigation>

</template>

<script>
    import $ from 'jquery';
import axios from 'axios'
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'

export default {
  metaInfo () {
    return {
      title: "AI Testing Suite | " + this.$appName
    }
  },

  computed: {
    ...mapState({
      me: state => state.me.me,
    })
  },

  components: {
    PanelNavigation
  },

  data () {
    return {
      model: "base",
      language: "ENG",
      prompt: "",

      sending: false,

      new_message: "",

      messageArray: []
    }
  },

  methods: {
    clearMessages() {
        this.messageArray = [];
    },
    deleteMessage(index) {
        let new_messages = [];

        for (var i in this.messageArray) {
            if (index != i) {
                new_messages.push(this.messageArray[i]);
            }
        }

        this.messageArray = JSON.parse(JSON.stringify(new_messages));
    },
    async sendMessage() {
        if (!this.new_message)
            return false;

        let self = this;

        self.sending = true;

        this.messageArray.push({
            role: "user",
            content: this.new_message
        });

        setTimeout(function() {
            var container1 = self.$el.querySelector("#messages_div");
            container1.scrollTop = container1.scrollHeight;
        }, 150);

        let response = await axios.post('https://api.bland.ai/chat/text', {
            callDetails: {
                language: this.language,
                params: "",
                task: this.prompt,
            },
            messageArray: this.messageArray,
            model: this.model
        }, {
            headers: {
                'content-type': 'application/json'
            },
        });

        this.new_message = '';
        this.sending = false;

        this.messageArray.push({
            role: "assistant",
            content: response.data.action_input
        });

        setTimeout(function() {
            var container2 = self.$el.querySelector("#messages_div");
            container2.scrollTop = container2.scrollHeight;
        }, 150);
        
    },
  },

  created() {
    
  }
}
</script>